import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { cnCalendar } from '../../Calendar.const';
import './Grid.css';
export var Grid = forwardRef(function Grid(props, ref) {
    var className = props.className, children = props.children, otherProps = __rest(props, ["className", "children"]);
    return (React.createElement("div", __assign({ ref: ref, className: cnCalendar('Grid', null, [className]) }, otherProps), children));
});
